import { collection, doc, getDoc, getDocs, orderBy, query, where } from 'firebase/firestore';
import Failure from '../../../core/Failure';
import { FirestoreCollections, firestore } from '../../../firebase.config';
import UserDoc from '../../models/UserDoc';

async function getUsersByCompanyId(companyId: string): Promise<UserDoc[]> {
  try {
    const db = firestore;

    const company = await getDoc(doc(db, FirestoreCollections.companies, companyId));
    const idSubscriptions = Object.keys(company.data()?.id_subscriptions || {});

    const usersCollection = collection(db, FirestoreCollections.users);

    // 1. Find users linked via subscriptions (users with a number)
    const subscriptionResults = (await Promise.all(
      idSubscriptions.map(subscriptionId =>
        getDocs(query(usersCollection, orderBy(`id_subscription.${subscriptionId}`, 'asc')))
      )
    )).flatMap(result => result.docs);

    // 2. Find users linked directly to the company via id_companies (e.g. users without a number)
    const companyMembersResult = await getDocs(
      query(usersCollection, orderBy(`id_companies.${companyId}`, 'asc'))
    );

    const allResults = [...subscriptionResults, ...companyMembersResult.docs];

    const users: UserDoc[] = [];
    allResults.forEach((doc) => {
      users.push(UserDoc.fromFirestore(doc));
    });

    // Remove dubblons (user with several numbers will be retrieved several times -> is it possible to improve ?)
    const filteredUsers = users.filter((user, index, array) => {
      return array.findIndex(t => t.id === user.id) === index;
    });

    return filteredUsers;
  } catch (e) {
    console.error('error: ', e);
    throw new GetUsersByCompanyIdFailure();
  }
}

export class GetUsersByCompanyIdFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getUsersByCompanyId;
